interface ShareBarProps {
  title: string;
  onMessage: (message: string) => void;
}

export default function ShareBar({ title, onMessage }: ShareBarProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      onMessage("链接已复制到剪贴板");
    } catch {
      onMessage("复制失败，请手动复制地址栏链接");
    }
  };

  const handleSocial = () => {
    onMessage("社交分享为演示功能，未实际发布内容");
  };

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
      <span className="flex items-center gap-1.5 text-sm font-medium text-foreground-700">
        <i className="ri-share-line text-lg" />
        分享这篇{title ? "资讯" : "内容"}
      </span>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={handleCopy}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
        >
          <i className="ri-link" />
          复制链接
        </button>
        <button
          type="button"
          onClick={handleSocial}
          aria-label="分享到微博（演示）"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 cursor-pointer"
        >
          <i className="ri-weibo-fill text-lg" />
        </button>
        <button
          type="button"
          onClick={handleSocial}
          aria-label="分享到微信（演示）"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 cursor-pointer"
        >
          <i className="ri-wechat-line text-lg" />
        </button>
        <button
          type="button"
          onClick={handleSocial}
          aria-label="分享到 X（演示）"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 cursor-pointer"
        >
          <i className="ri-twitter-x-line text-lg" />
        </button>
      </div>
    </div>
  );
}